import { connect } from 'react-redux';

import RequestTemplate from './RequestTemplate';
import { SERVICE_TYPE } from 'app/developer-v3/constants';
import { currentPlatformVariablesList } from 'app/developer-v3/selectors';
import { saveRequestTemplate } from 'app/developer-v3/Actions';
import {
  selectDefinitionOverride,
  selectIsAppVersionSaving,
} from 'app/developer-v3/store/selectors';

const mapStateToProps = state => ({
  initialRequestTemplate:
    selectDefinitionOverride(state)?.requestTemplate ?? false,
  isSaving: selectIsAppVersionSaving(state),
  getSuggestions: currentPlatformVariablesList(
    SERVICE_TYPE.authentication,
    state
  ),
});

export default connect(mapStateToProps, {
  onSave: saveRequestTemplate,
})(RequestTemplate);
